import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
type PillButtonProps = {
  href: string;
  children: React.ReactNode;
  variant?: "accent" | "dark" | "white";
  size?: "md" | "sm";
};
const styles = {
  accent: {
    base: "bg-accent text-ink hover:bg-[#F0572F]",
    circle: "bg-ink text-white"
  },
  dark: {
    base: "bg-ink text-white hover:bg-[#262626]",
    circle: "bg-accent text-ink"
  },
  white: {
    base: "bg-white text-ink hover:bg-cream",
    circle: "bg-ink text-white"
  }
};
export function PillButton({
  href,
  children,
  variant = "accent",
  size = "md"
}: PillButtonProps) {
  const s = styles[variant];
  const sizing = size === "md" ? "h-12 pl-6 pr-1.5 text-[14px] gap-4" : "h-10 pl-4 pr-1 text-[13px] gap-3";
  const circle = size === "md" ? "h-9 w-9" : "h-8 w-8";
  return <a href={href} className={`group inline-flex shrink-0 items-center whitespace-nowrap rounded-full font-semibold transition-colors duration-150 ${sizing} ${s.base}`} data-id="element-209" data-mp="28x025lud5rzy">
      {children}
      <span className={`flex items-center justify-center rounded-full ${circle} ${s.circle}`} data-id="element-210" data-mp="3rvd8naz4s99q">
        <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:rotate-45" strokeWidth={2} aria-hidden="true" data-id="element-211" data-mp="3mwjt7d0aa86x" />
      </span>
    </a>;
}